import { makeStyles, createStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material'
import React from 'react'
import { WarehouseGrid } from '../../../interfaces/Warehouse/Warehouse'

import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import Avatar from '@mui/material/Avatar'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import WorkIcon from '@mui/icons-material/Work'
import Divider from '@mui/material/Divider'
import StoreIcon from '@mui/icons-material/Store'
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus'
import DescriptionIcon from '@mui/icons-material/Description'

interface ViewAlmacenProps {
  elemento: WarehouseGrid
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    table: {
      minWidth: 400
    },
    root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper
    }
  })
)

function toDia(value: number): string {
  switch (value) {
    case 1:
      return 'Lunes'
    case 2:
      return 'Martes'
    case 3:
      return 'Miercoles'
    case 4:
      return 'Jueves'
    case 5:
      return 'Viernes'
    case 6:
      return 'Sabado'
    case 7:
      return 'Domingo'

    default:
      return 'Lunes'
  }
}

export const ViewAlmacen: React.FC<ViewAlmacenProps> = ({ elemento }) => {
  const classes = useStyles()
  return (
    <Grid container direction='row' spacing={2}>
      <Grid item xs={12} md={6}>
        <List className={classes.root}>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <StoreIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary='Nombre Almacén'
              secondary={elemento.warehouseName}
            />
          </ListItem>
          <Divider variant='inset' component='li' />
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <WorkIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary='Código Almacén'
              secondary={elemento.warehouseCode}
            />
          </ListItem>
          <Divider variant='inset' component='li' />
        </List>
      </Grid>
      <Grid item xs={12} md={6}>
        <List>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <DirectionsBusIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary='Dirección'
              secondary={elemento.warehouseAddress}
            />
          </ListItem>
          <Divider variant='inset' component='li' />
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <CheckBoxIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary='Activo'
              secondary={elemento.active ? 'Si' : 'No'}
            />
          </ListItem>
          <Divider variant='inset' component='li' />
        </List>
      </Grid>

      <Grid item xs={12}>
        <List>
          <ListItem>
            <ListItemAvatar>
              <Avatar>
                <DescriptionIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary='Descripción'
              secondary={elemento.warehouseDescription}
            />
          </ListItem>
          <Divider variant='inset' component='li' />
        </List>
      </Grid>

      {elemento.warehouseSchedule && elemento.warehouseSchedule.length > 0 && (
        <Grid item xs={12}>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label='simple table'>
              <TableHead>
                <TableRow>
                  <TableCell align='center'>Dia</TableCell>
                  <TableCell align='center'>Horario Inicio</TableCell>
                  <TableCell align='center'>Horario Fin</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {elemento.warehouseSchedule.map((row) => (
                  <TableRow key={row.id}>
                    <TableCell align='center'>{toDia(row.dayId)}</TableCell>
                    <TableCell align='center'>{row.start}</TableCell>
                    <TableCell align='center'>{row.end}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      )}
    </Grid>
  )
}
